import { createScopedRouterHelpers } from "@circle-react/utils/router/createScopedRouterHelpers";

import type { PaywallCheckoutRouter } from "./PaywallCheckoutAppRouter";

const scopedRouterHelpers = createScopedRouterHelpers<PaywallCheckoutRouter>();

export const { useScopedNavigate, useScopedParams } = scopedRouterHelpers;
